<div
  #header
  class="drawer-header"
  [id]="'qa-drawer-header-' + modalId"
  [class.drawer-header--roll]="shouldShowHeaderBorder"
  [class.drawer-header--swiper]="shouldShowSwiper"
  [attr.tabindex]="shouldShowSwiper ? -1 : 0"
>
  <button
    *ngIf="shouldShowSwiper"
    class="drawer-header__swiper"
    tabindex="-1"
    [id]="'qa-btn-swiper-' + modalId"
    (panDown)="swipeDown($event)"
    (panend)="panEnd()"
  ></button>
  <ng-container *ngIf="!shouldShowSwiper">
    <h2 class="drawer-header__title" [id]="'qa-drawer-title-' + modalId">{{ title }}</h2>
    <button
      class="drawer-header__close"
      [id]="'qa-close-btn-' + modalId"
      [attr.aria-label]="'aria.close-dialog' | translate"
      (click)="close()"
    >
      <i class="fa-regular fa-xmark"></i>
    </button>
  </ng-container>
</div>
<h5
  *ngIf="shouldShowSwiper"
  class="drawer-header__title drawer-header__title--swiper"
  [id]="'qa-drawer-title-swiper' + modalId"
>
  {{ title }}
</h5>
